import { Box, Heading, Paragraph } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import React from 'react';
import SkeletonContainer from '../SkeletonContainer';

export const LeadSummaryCountsSkeleton = () => {
  const titles = ['Total contacts', 'Total leads', 'Total website referrals'];

  return (
    <Box css={{ display: 'flex' }}>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Heading level={2} textStyle="heading-xs">
          Contacts
        </Heading>
        <Paragraph textStyle="body" css={{ marginTop: 'tighter' }}>
          Contacts are a combination of leads and website referrals
        </Paragraph>
      </Box>

      <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
        {titles.map((title) => {
          return (
            <Box key={title} css={{ display: 'flex', flexDirection: 'column' }}>
              <Paragraph css={{ color: 'coolGray.500', whiteSpace: 'nowrap' }}>{title}</Paragraph>
              <Skeleton />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export const Skeleton = () => (
  <SkeletonContainer>
    <Bone css={{ marginTop: 'tighter', marginBottom: 'tight', width: '40px' }} />
  </SkeletonContainer>
);
